module.exports = __webpack_public_path__ + "img/bg_page.9df44da2.png";